import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { GlobalNotificationService } from '../../services/globalnotification.service';
import { Observable, takeUntil, debounceTime, Subject } from 'rxjs';
import { RTAOptions } from '../../interfaces/request.interface';
import { UserViewModel } from '../../interfaces/viewmodels/userviewmodel';
import { RequestActions } from '../../store/action/request.action';
import { AccountState } from '../../store/state/account.state';
import { OptionState } from '../../store/state/options.state';
import { SecondaryMeasurementUnits } from '../../interfaces/request';

@Component({
    selector: 'app-secondary-data',
    templateUrl: './secondary-data.component.html',
    styleUrl: './secondary-data.component.css',
    standalone: false
})
export class SecondaryDataComponent {
  public secondaryData!: FormGroup;
  public user$!: Observable<UserViewModel>;
  public rtaOptions$!: Observable<RTAOptions[]>;
  private destroy$ = new Subject<void>();

  public SecondaryMeasurementUnits$: SecondaryMeasurementUnits | undefined;

  constructor(private fb: FormBuilder, private store: Store, private route: ActivatedRoute,
    private globalNotificationService: GlobalNotificationService) {
  }

  ngOnInit(): void {
    this.user$ = this.store.select(AccountState.user);
    this.rtaOptions$ = this.store.select(OptionState.options);

    this.rtaOptions$
      .pipe(takeUntil(this.destroy$))
      .subscribe(opts => this.processOptions(opts));


  }
  public onValueChangeSlider(value: any, parameterName: string): void {

  }
  public changeIndividualTick(parameterName: string) {
  }
  private processOptions(options: RTAOptions[]) {
    
  }
}
